import { render, staticRenderFns } from "./ModalTrocaNome.vue?vue&type=template&id=57229ac0&scoped=true"
import script from "./ModalTrocaNome.vue?vue&type=script&lang=js"
export * from "./ModalTrocaNome.vue?vue&type=script&lang=js"
import style0 from "./ModalTrocaNome.vue?vue&type=style&index=0&id=57229ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57229ac0",
  null
  
)

export default component.exports